import React from "react";
import "../styles.css";
import "../popup.css";
import "../try.css";

import "./Contact.css";
import { Component } from "react";
import Nav from "./navbar";

import Footer from "./footer";

class Resume extends Component {
  render() {
    return (
      <>
        <Nav />
        <div className="resume-flex">
          <div className="marg3tbrem">
            {" "}
            <h2>Education</h2>{" "}
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default Resume;
